<template>
  <el-card>
    <div class="wrap-header">
      <header class="header">
        <div class="header-left"></div>
        <div class="content">
          <p>{{data.package_name}}</p>
          <h1>{{data.lesson_name}}</h1>
        </div>
        <div class="header-right"></div>
      </header>

      <div class="name">
        <p>姓名：{{data.real_name}}</p>
        <span>存档日期：{{data.updated_at | date('Y/m/d')}}</span>
      </div>

      <div class="wrap-lesson">
        <template v-for="item in data.work_info">
          <div
            class="lesson"
            v-if="item.type !== 7"
            :key="item.id"
            :style="{background: `url(${item.preview_url}) no-repeat 100%/cover`}"
          >
            <div class="lesson-left">
              <p>{{item.name}}</p>
              <span @click="view(item)">点击查看作品</span>
            </div>
            <div class="lesson-right" :id="`qr-code-${item.id}`"></div>
          </div>
        </template>
      </div>

      <div class="progress">
        <div class="image">
          <img :src="data.growth_template_info && data.growth_template_info.lesson_progress"/>
        </div>
      </div>
      <div class="scroll">
        <i class="arrow left"></i>
        <span>左右滑动查看更多</span>
        <i class="arrow right"></i>
      </div>
    </div>
  </el-card>
</template>

<script>
import QRCode from 'qrcodejs2'
import { Card } from 'element-ui'

export default {
  components: {
    'ElCard': Card
  },
  data () {
    return {
      modalLink: '',
      qrcode: {}
    }
  },
  props: ['data'],
  watch: {
    'data': {
      handler (val) {
        this.$nextTick(() => {
          val.work_info && val.work_info.map(row => {
            if (row.type === 7) return
            this.qrCode = new QRCode(document.getElementById(`qr-code-${row.id}`), {
              text: row.type === 5 ? `${window.CONFIG.box}/w/${row.id}` : `${CONFIG.ide}/we/${row.id}`,
              width: 66,
              height: 66,
              colorDark: '#000000',
              colorLight: '#ffffff'
            })
          })
        })
      },
      immediate: true
    }
  },
  methods: {
    async view (s) {
      const type = s.type
      if (type === 1 || type === 4 || type === 6 || type === 0) {
        this.modalLink = `${CONFIG.player}/we/${s.id}`
      } else if (type === 5) {
        this.modalLink = `${window.CONFIG.box}/w/${s.id}`
      }
      window.open(this.modalLink, '_self')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './view.styl';

.wrap-header {
  position: relative;

  .header {
    position: relative;
    width: 115%;
    left: -20px;
    top: -20px;
  }
}

.content {
  margin: 0 19px;
  text-align: center;
  color: #21a795;
  font-weight: 400;

  p {
    font-size: 14px;
  }

  h1 {
    font-size: 22px;
  }
}

.header-left, .header-right {
  width: 29px;
  height: 53px;
  background: url('https://public-static-edu.codemao.cn/redboat/courseManage/标题左装饰.png') no-repeat 100% / cover;
}

.header-right {
  transform: rotate(180deg);
}

.name {
  display: inline-block;
  width: 100%;
  position: relative;
  top: -30px;
  color: #666;
  text-align: center;
  font-size: 12px;

  p {
    margin-bottom: 5px;
  }
}

.wrap-lesson {
  display: flex;
  flex-wrap: wrap;
}

.lesson {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 100px;
  position: relative;
  border-radius: 10px;
  z-index: 1;
  padding: 15px 11px;
  box-sizing: border-box;
  box-shadow: 0px 6px 12px 0px rgba(0, 196, 170, 0.1);

  &:first-child {
    margin-bottom: 15px;
  }
}

.lesson::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100px;
  border-radius: inherit;
  background: rgba(0, 0, 0, 0.2);
}

.lesson-left {
  flex: 1;
  padding-right: 8px;
  position: relative;

  p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 13px;
    font-size: 12px;
    color: rgba(255, 255, 255, 1);
    line-height: 19px;
    text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    font-weight: bold;
  }

  span {
    font-size: 12px;
    display: inline-block;
    padding: 3px 6px;
    background: rgba(255, 255, 255, 1);
    border-radius: 13px;
    text-align: center;
    line-height: 14px;
    color: $themeColor;
    cursor: pointer;
    position: absolute;
    top: 50px;
  }
}

.lesson-right {
  border: 2px solid #00c4aa;
  background: #fff;
  align-self: center;
}

.progress {
  border-radius: 10px;
  border: 1px solid rgba(0, 196, 170, 1);
  margin: 15px auto;
  overflow: auto;

  .image {
    width 200%;
    height: 186px;
  }
}

.scroll {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
  font-size: 12px;

  span {
    margin: 0 5px;
  }

  .arrow {
    display: inline-block;
    height: 1px;
    width: 12px;
    background-color: #ddd;
    position: relative;
  }

  .left:before {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    border: 4px solid transparent;
    border-right: 6px solid #ddd;
    left: -10px;
    top: -3.15px;
  }

  .right:before {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    border: 4px solid transparent;
    border-left: 6px solid #ddd;
    left: 12px;
    top: -3.15px;
  }

  .left {
    animation: move-left infinite 2s;
  }

  .right {
    animation: move-right infinite 2s;
  }

  @keyframes move-left {
    0% {
      transform: translateX(0px);
    }

    100% {
      transform: translateX(-10px);
    }
  }

  @keyframes move-right {
    0% {
      transform: translateX(0px);
    }

    100% {
      transform: translateX(10px);
    }
  }
}
</style>
